import { AccountListStatus } from '../..'
import { Tab } from '@/features/ui/navigation'
import Badge from '@/features/ui/navigation/Tab/parts/Badge'
import { BadgeSlotProps } from '@/features/ui/navigation/Tab/types'
import { FC, useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { Pressable, StyleSheet } from 'react-native'

interface StatusTabProps {
    status: AccountListStatus
    active: boolean
    count: number
    onPress: (status: AccountListStatus) => void
}

const StatusTab: FC<StatusTabProps> = ({ status, active, count, onPress }) => {
    const { t } = useTranslation('app')
    const CountBadge = useCallback(
        ({ active }: BadgeSlotProps) => <Badge inverted={!active}>{String(count)}</Badge>,
        [count]
    )

    return (
        <Pressable
            accessibilityRole="tab"
            aria-selected={active}
            onPress={() => onPress(status)}
            style={({ pressed }) => [styles.container, pressed && styles.pressed]}
        >
            <Tab active={active} Badge={CountBadge}>
                {t(`openTabs.accountList.tabs.${status}`)}
            </Tab>
        </Pressable>
    )
}

const styles = StyleSheet.create({
    container: { minHeight: 36, justifyContent: 'center' },
    pressed: { opacity: 0.72 },
})

export default StatusTab
